import React, { useState } from 'react';

import data from './data';

import skillBarFaded from './img/skillBar-faded.png';

import * as css     from './skill-bar.module.css';
import * as cssComp from './comp.module.css';

import { i18n } from '../../i18n';

export default function SkillBar() {
    const [ selected, setSelected ] = useState();

    return <div className='section'>
        <div className={css.skillBar}>

            <div className={cssComp.comp}>

                {selected ? <img src={skillBarFaded} className={css.faded}/> : null}

                {data.keys.map(key => {
                    const { img }   = data.info[key];
                    const className = selected === key ? cssComp[`${key}Selected`] : cssComp[key];

                    return <div key={key} className={className}><img src={img} /></div>;
                })}
            </div>

            {/* svg for click/hover targets */}
            <svg className={css.svg} xmlns="http://www.w3.org/2000/svg" width="901" height="146" viewBox="0 0 901 146">
                {data.keys.map(key => {
                    const { svg, label } = data.info[key];

                    if (typeof svg.x !== 'undefined') {
                        return <rect key={label} onMouseEnter={() => setSelected(key)} onMouseLeave={() => setSelected()} x={svg.x} y={svg.y} width={svg.width} height={svg.height} />;
                    }

                    if (svg.cx) {
                        return <circle key={label} onMouseEnter={() => setSelected(key)} onMouseLeave={() => setSelected()} cx={svg.cx} cy={svg.cy} r={svg.r} />;
                    }

                    if (svg.d) {
                        return <path key={label} onMouseEnter={() => setSelected(key)} onMouseLeave={() => setSelected()} d={svg.d} />;
                    }

                    return <div key={label} id={label}>error</div>;
                })}
            </svg>
        </div>

        {/* list */}
        <ul className={css.list}>
            {data.keys.map(key => {
                const className = selected === key ? css.itemSelected : css.item;
                const item      = data.info[key];

                return <li className={className} key={key} onMouseEnter={() => setSelected(key)} onMouseLeave={() => setSelected()}>
                    {/* "slot(s)" header*/}
                    {item.header ? <h4 className={css.slotHeader}>{i18n(item.header)}</h4> : null}


                    {/* icon, or circle with slot number */}
                    <div className={css[`${key}Icon`]}>
                        {item.slots ?
                            item.slots.map((slot, idx) =>
                                // add a "-" if not the first
                                (idx ? <><span className={css.dash}> - </span><div>{slot}</div></> : <div key={slot}>{slot}</div>)) :
                            <span className={css.iconImgWrap}><img src={item.img} /></span>
                        }
                    </div>

                    {/* label */}
                    <div>
                        <p className={css.label}>{i18n(item.label)}</p>
                    </div>
                </li>;
            })}
        </ul>
    </div>;
}
